import React, { useCallback, useContext, useEffect, useState } from 'react';
import { SyncOutlined, ReloadOutlined } from '@ant-design/icons';
import { Button, PageHeader, Table, Layout } from 'antd';
import { apiClient, apiErrorMessage, hasPermission } from '../../../utils';
import { UserContext } from '../../contexts';
import { Cell } from '../../../models/index';

const { Content } = Layout;

export function CellsPage() {
  const { user } = useContext(UserContext);
  const [cells, setCells] = useState<Cell[]>();
  const [canEdit, setCanEdit] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setCanEdit(hasPermission(user, 'productionSites.sync_sap'));
  }, [user]);

  const loadCells = useCallback(() => {
    setLoading(true);
    apiClient
      .get(`production-sites/cells`)
      .then((response: any) => {
        const responseCells: Cell[] = response.data;
        const responseData = responseCells.map(cell => {
          return {
            key: cell.id,
            ...cell,
          };
        });
        setCells(responseData);
        setLoading(false);
      })
      .catch((reason: any) => {
        setLoading(false);
        apiErrorMessage(reason);
      });
  }, []);

  useEffect(() => {
    loadCells();
  }, [loadCells]);

  const onRefreshClick = () => {
    loadCells();
  };

  const onSyncClick = () => {};

  const tableColumns: any[] = [
    {
      title: 'Hücre no',
      dataIndex: 'code',
      key: 'code',
    },
    {
      title: 'İsim',
      dataIndex: 'name',
      key: 'name',
    },
  ];

  return (
    <>
      <PageHeader
        extra={[
          <Button key="refresh" onClick={onRefreshClick} icon={<ReloadOutlined />}>
            Yenile
          </Button>,
          <>
            {canEdit && (
              <Button type="primary" key="sync" onClick={onSyncClick} icon={<SyncOutlined />}>
                SAP ile eşle
              </Button>
            )}
          </>,
        ]}
      />
      <Content>
        <Table columns={tableColumns} dataSource={cells} loading={loading} pagination={false} />
      </Content>
    </>
  );
}
